export default __webpack_public_path__ + "static/media/Montserrat-Medium.e2d60bc4.ttf";